export default __webpack_public_path__ + "static/media/solution_01.28bc3a18.png";